<template>
  <div>
    <b-navbar type="is-info" style="box-shadow: 0 3px 3px 0 lightgrey">
      <template slot="brand">
        <b-navbar-item
          href="/"
          style="display: flex; align-items: center; gap: 8px"
        >
          <img
            src="/images/logo-dark-background-38.png"
            alt="Wheel of Names"
            style="height: 38px; width: auto; border-radius: 8px"
          />
          <span style="font-size: 24px">wheelofnames.com</span>
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item @click="showToast('New wheel created')">
          <i class="fas fa-file fa-fw"></i>&nbsp;New
        </b-navbar-item>
        <b-navbar-item @click="showToast('Open feature coming soon')">
          <i class="fa fa-folder-open fa-fw"></i>&nbsp;Open
        </b-navbar-item>
        <b-navbar-item @click="showToast('Save feature coming soon')">
          <i class="fa fa-save fa-fw"></i>&nbsp;Save
        </b-navbar-item>
        <b-navbar-item @click="showToast('Share feature coming soon')">
          <i class="fa fa-share-alt fa-fw"></i>&nbsp;Share
        </b-navbar-item>
        <b-navbar-item @click="showToast('Customize feature coming soon')">
          <i class="fas fa-palette fa-fw"></i>&nbsp;Customize
        </b-navbar-item>
        <b-navbar-item @click="showToast('Fullscreen feature coming soon')">
          <i class="fa fa-expand fa-fw"></i>&nbsp;Fullscreen
        </b-navbar-item>
        <b-navbar-dropdown label="More" :right="true">
          <b-navbar-item @click="$store.commit('toggleDarkMode')">
            <i class="fas fa-moon fa-fw"></i>&nbsp;{{
              darkMode ? 'Light Mode' : 'Dark Mode'
            }}
          </b-navbar-item>
          <b-navbar-item @click="toggleRiggingPanel">
            <i class="fas fa-sliders-h fa-fw"></i>&nbsp;Rig
          </b-navbar-item>
          <b-navbar-item @click="aboutModalActive = true">
            <i class="fas fa-info-circle fa-fw"></i>&nbsp;About
          </b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-item tag="div" href="#">
          <b-select v-model="locale">
            <option value="en">English</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="de">Deutsch</option>
          </b-select>
        </b-navbar-item>
      </template>
    </b-navbar>

    <b-modal :active.sync="aboutModalActive" has-modal-card trap-focus>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">About Wheel of Blames</p>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <p>
              This project is a fork of the wheel-spinner
              (https://github.com/momander/wheel-spinner), originally used to
              create the `wheelofnames.com` website.
            </p>

            <p>
              This version allows you to rig the result in various ways. Use the
              "Rig" option in the More menu, or on desktop hover your cursor
              to the right of the screen.
            </p>

            <p>Use this for fun purposes only.</p>

            <hr />
            <p style="font-size: 0.9em; color: #666">
              <em>Created by: add-something-here</em>
            </p>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button @click="aboutModalActive = false">Close</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      locale: 'en',
      aboutModalActive: false,
    }
  },
  computed: {
    ...mapGetters(['darkMode']),
  },
  methods: {
    showToast(message) {
      this.$buefy.toast.open({
        message: message,
        duration: 2000,
        type: 'is-info',
      })
    },
    toggleRiggingPanel() {
      this.$root.$emit('toggle-rigging-panel')
    },
  },
}
</script>
